/* tslint:disable */
import { User } from './user';

/**
 */
export class ViewLogin {
    token?: string;
    user?: User;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-login.ts